module.exports = __webpack_public_path__ + "static/media/money_market_moderate.f3e6742b.svg";